import React from 'react';
import { MessageCircle, Mail, Instagram } from 'lucide-react';
import Logo from './Logo';

export default function Footer({ socialLinks }) {
    return (
        <footer className="bg-black text-gray-400 py-12 px-4 border-t border-gray-800">
            <div className="max-w-7xl mx-auto">
                <div className="grid md:grid-cols-4 gap-8 mb-8">
                    <div>
                        <div className="flex items-center gap-2 mb-4">
                            <Logo className="w-6 h-6" />
                            <h3 className="text-white font-bold text-lg">Roldan Eng. Software</h3>
                        </div>
                        <p className="text-sm">Desenvolvimento ágil para PMEs</p>
                    </div>
                    <div>
                        <h3 className="text-white font-bold mb-4">Serviços</h3>
                        <ul className="text-sm space-y-2">
                            <li><a href="#servicos" className="hover:text-cyan-400">Desenvolvimento</a></li>
                            <li><a href="#servicos" className="hover:text-cyan-400">Landing Pages</a></li>
                            <li><a href="#servicos" className="hover:text-cyan-400">Automações</a></li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-white font-bold mb-4">Empresa</h3>
                        <ul className="text-sm space-y-2">
                            <li><a href="#processo" className="hover:text-cyan-400">Processo</a></li>
                            <li><a href="#faq" className="hover:text-cyan-400">FAQ</a></li>
                            <li><a href="#contato" className="hover:text-cyan-400">Contato</a></li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-white font-bold mb-4">Redes Sociais</h3>
                        <div className="flex gap-4">
                            <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400">
                                <Instagram size={20} />
                            </a>
                            <a href={socialLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400">
                                <MessageCircle size={20} />
                            </a>
                            <a href={socialLinks.email} className="hover:text-cyan-400">
                                <Mail size={20} />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="border-t border-gray-800 pt-8 text-center text-sm">
                    <p>© 2025 Roldan Eng. Software. Todos os direitos reservados.</p>
                </div>
            </div>
        </footer>
    );
}
